"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerAreaMenuItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const material_1 = require("@mui/material");
const isResellerOnSelfStore_1 = require("../../../utils/isResellerOnSelfStore");
const MenuDrawer_styled_1 = require("../../../../components/MenuDrawer/MenuDrawer.styled");
const constants_1 = require("../../../constants");
const content_1 = __importDefault(require("../../../content"));
const CustomerAreaMenuItem_types_1 = require("./CustomerAreaMenuItem.types");
const react_1 = require("react");
const handlers_1 = require("./handlers");
const hooks_1 = require("../../../../hooks");
/**
 * @function getCurrentActiveItem
 * @returns {string | undefined} Retorna o item ativo da área do cliente ['orders' | 'profile']. Caso não esteja na Área do Consumidor, retorna undefined.
 */
const getCurrentActiveItem = () => {
    const currentPath = window.location.href;
    const isCustomerArea = currentPath.includes(constants_1.CUSTOMER_AREA_PATH);
    if (currentPath.includes(constants_1.CUSTOMER_AREA_FAVORITES_PATH)) {
        return 'favorites';
    }
    if (!isCustomerArea) {
        return undefined;
    }
    if (currentPath.includes(constants_1.CUSTOMER_AREA_ORDERS_PATH)) {
        return 'orders';
    }
    else if (currentPath.includes(constants_1.CUSTOMER_AREA_PROFILE_PATH)) {
        return 'profile';
    }
};
const Item = ({ isActive, name, Icon, onClick }) => {
    const highlightBgColor = MenuDrawer_styled_1.highlightBackgroundColor[constants_1.BUSINESS_UNIT];
    return ((0, jsx_runtime_1.jsx)(material_1.ListItem, Object.assign({ disablePadding: true }, { children: (0, jsx_runtime_1.jsxs)(flora_react_1.Button, Object.assign({ variant: "unstyled", css: { height: 'inherit' }, "autotagging-flora": "on", "data-autotagging-flora-section": "menu", "data-flora-text": name, as: material_1.ListItemButton, sx: {
                height: 56,
                backgroundColor: isActive ? highlightBgColor : 'inherit',
            }, onClick: onClick }, { children: [(0, jsx_runtime_1.jsx)(material_1.ListItemIcon, Object.assign({ sx: { minWidth: 0, marginRight: '10px' } }, { children: Icon })), (0, jsx_runtime_1.jsx)(material_1.ListItemText, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ size: "bodyLargeShortRegular" }, { children: name })) })] })) })));
};
const checkResellerInfo = (catalogSlug, callback) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const result = yield (0, isResellerOnSelfStore_1.isResellerOnSelfStore)(catalogSlug);
        callback === null || callback === void 0 ? void 0 : callback(result);
    }
    catch (error) {
        callback === null || callback === void 0 ? void 0 : callback(false);
    }
});
const CustomerAreaMenuItem = ({ catalogSlug }) => {
    const { isLogged } = (0, hooks_1.useCustomer)();
    const { totalOfFavorites, isFavoritesEnabled } = (0, hooks_1.useFavorites)();
    const currentActiveItem = getCurrentActiveItem();
    (0, react_1.useEffect)(() => {
        checkResellerInfo(catalogSlug || '');
    }, [catalogSlug]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isFavoritesEnabled && ((0, jsx_runtime_1.jsx)(Item, { Icon: (0, jsx_runtime_1.jsx)(flora_react_icons_1.HeartOutlineIcon, { color: "$nonInteractivePredominant" }), name: content_1.default.menuItem.favorites, isActive: currentActiveItem === 'favorites', onClick: () => (0, handlers_1.handleClickItem)(CustomerAreaMenuItem_types_1.MenuItemCustomerAreaAccessType.favorites, true, catalogSlug) })), (0, jsx_runtime_1.jsx)(Item, { Icon: (0, jsx_runtime_1.jsx)(flora_react_icons_1.BoxIcon, { color: "$nonInteractivePredominant" }), name: content_1.default.menuItem.orders, isActive: currentActiveItem === 'orders', onClick: () => (0, handlers_1.handleClickItem)(CustomerAreaMenuItem_types_1.MenuItemCustomerAreaAccessType.orders, isLogged, catalogSlug) }), (0, jsx_runtime_1.jsx)(Item, { Icon: (0, jsx_runtime_1.jsx)(flora_react_icons_1.PersonIcon, { color: "$nonInteractivePredominant" }), name: content_1.default.menuItem.profile, isActive: currentActiveItem === 'profile', onClick: () => (0, handlers_1.handleClickItem)(CustomerAreaMenuItem_types_1.MenuItemCustomerAreaAccessType.profile, isLogged, catalogSlug) })] }));
};
exports.CustomerAreaMenuItem = CustomerAreaMenuItem;
